import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AttachmentService } from '../../../attachment/attachment.service';
import { ProjectService } from '../../../../resources/project/project.service';
import { Editor } from 'tinymce';
import { TinymceService } from '../../../tinymce/tinymce.service';
import { ProjectElement } from '../../../../resources/element/project-element.interface';
import { AuthService } from '../../../../auth/auth.service';

/**
 * Open TinyMCE in modal.
 *
 * @todo Instead of accepting a complete element, accept two props:
 *  - `value`: Value to edit/return.
 *  - `title`: Optional title to display.
 */
@Component({
  selector: 'sg2-tinymce',
  templateUrl: './tinymce.component.html',
  styleUrls: ['./tinymce.component.less']
})
export class ModalTinyMCEComponent {

  /** Active editor instane. */
  private editor: Editor;

  /** Current element. */
  public element: ProjectElement;

  /** Tiny MCE config. */
  public TinyMCEConfig = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly config: any,
    private attachmentService: AttachmentService,
    private authService: AuthService,
    public dialogRef: MatDialogRef<ModalTinyMCEComponent>,
    private projectService: ProjectService,
    private tinymceService: TinymceService
  ) {
    this.element = Object.assign({}, config.element);
    this.element.value = this.tinymceService.sanitizeInput(this.element.value);
    this._initTinyMCE();
  }

  /**
   * Submit.
   */
  public submit(): void {
    this.dialogRef.close(this.tinymceService.sanitizeOutput(this.editor.getContent()));
  }

  /**
   * Initialize Tiny MCE.
   */
  private _initTinyMCE(): void {
    this.TinyMCEConfig = {
      branding: false,
      formats: {
        bold: { inline: 'strong' },
        italic: { inline: 'i' }
      },
      fixed_toolbar_container: '#toolbar-container-tinymce',
      menubar: false,
      images_reuse_filename: true,
      images_upload_handler: (blobInfo, success, failure) => {
        this.attachmentService.uploadImageElement(blobInfo.filename(), blobInfo.base64()).subscribe(resolve => {
          success(`/api/project/v2/${ this.projectService.getId() }/element/image/${ resolve.location }`);
        });
      },
      init_instance_callback: (editor: Editor) => {
        this.editor = editor;
      },
      nonbreaking_force_tab: true,
      paste_data_images: true,
      plugins: 'paste table lists textcolor nonbreaking code',
      toolbar: 'fontselect | fontsizeselect | bold italic underline strikethrough '
        + '| forecolor backcolor | bullist numlist | alignleft aligncenter alignright alignjustify | table'
        + (this.authService.isAdmin() ? ' | code' : ''),
      extended_valid_elements: 'b,strong,em,i'
    };
  }
}
